/**
 * Blocks the first paint until the persisted session is restored, so the app
 * never flashes the logged-out / mock state before the token check completes.
 * Mirrors the existing visual language (no UI redesign) — a small centered spinner.
 */

import type { ReactNode } from "react";
import { useSessionRestore } from "@/features/auth/useSessionRestore";

export function SessionGate({ children }: { children: ReactNode }) {
  const restoring = useSessionRestore();

  if (restoring) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-primary" />
          <p className="text-xs text-text3">Restauration de la session…</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
